exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toast-notification {\n  margin: auto;\n  opacity: 1;\n  padding: 1em;\n  position: absolute;\n  top: 0;\n  transition-duration: 250ms;\n  transition-timing-function: ease-out;\n  transition-property: top, opacity;\n  width: 100%;\n  z-index: 1000; }\n  .toast-notification.toast-notification-closed {\n    opacity: 0;\n    top: -2em; }\n  .toast-notification .notification {\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);\n    margin-left: auto;\n    max-width: 512px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/component/notification/styles.scss
// module id = 783
// module chunks = 0